
import { BrowserRouter as Link, } from "react-router-dom";
import { Navbar, Nav, Button, FormControl, Dropdown, Image, Row } from 'react-bootstrap';
import { HeartFil, HeartFill } from 'react-bootstrap-icons'
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css'

import openCapacitorSite from '../../utils/browserUtils';








export const About = () =>   {

    {
    return(
       <>

       <div id='homebg'>
        <br></br>
       <div id='mobileNavbarSpacer'></div>

           <div id='homebg'>  
           <div id='textPageMobile' style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        textAlign: 'center' 
                    }}>
           <h3 id='aboutParagraph'>About</h3>
           <p id='aboutParagraph'>Gov Glance is a civic engagement tool designed to help citizens 
                                      get official government news in an easy-to-navigate centralized location. 
                                  There will never be any opinion or political analysis(That's your job), only information from official government 
                                  sources.
                                  </p>
                    
                                  <p id='aboutParagraph'>
                                  Gov Glance Foundation Inc. is a non-profit dedicated to creating free educational tools and resources. <a id='aboutLink' href='https://govglance.foundation/'>https://govglance.foundation/</a>
                                  </p>
                                 
                                  <div id='centerButton'><Button id='allPageButtonMobile' onClick={(e) => {
                                            e.preventDefault();
                                            openCapacitorSite('https://donate.stripe.com/28o3fXbdvbQO2RO288')
                                          }}><HeartFill id='donateIcon'/>    Donate</Button></div>
       
                  </div>
                      </div>

 
         
          </div>

          </>
  )
}
 }



  






export default About;




